import predicates from '../predicates'
import selectors from '../selectors'
import { RSS_TRAFFIC_SOURCE } from '../constants'

const rss = {
  rule: predicates.searchParamEqualsOne('utm_source', 'rss'),
  extractor: traffic => {
    const trafficSource = RSS_TRAFFIC_SOURCE
    const trafficId = selectors.referrerHostname(traffic)

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default rss



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/pipelines/rss.js